// 以流程設定租戶各階段共用的小工具

// 把 axios 錯誤轉成可直接顯示的文字。後端回應有三種形狀：
// {error: '...'}、DRF serializer 的 {field: ['...']}、或純字串
export function errorText(error) {
  const data = error && error.response && error.response.data;
  if (!data) {
    return (error && error.message) || 'Error';
  }
  if (typeof data === 'string') {
    return data;
  }
  if (data.error) {
    return typeof data.error === 'string' ? data.error : JSON.stringify(data.error);
  }
  return Object.entries(data)
    .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(' ') : value}`)
    .join('\n');
}

// 以 JSON 字串比較畫面內容與初始狀態，判斷是否有異動
export function snapshot(value) {
  return JSON.stringify(value);
}
